import style, { createGlobalStyle } from 'styled-components';

export const AppleBtnGlobalStyle = createGlobalStyle`
    apple-pay-button {
        --apple-pay-button-width: 100%;
        --apple-pay-button-height: 48px;
        --apple-pay-button-border-radius: 12px;
        --apple-pay-button-padding: 0px;
    }
`;

export const AppleBtnWrapper = style.div`
    min-width: 250px;
    height: 48px;
`;
